import React from "react";
import "../styles/Footer.scss";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import playstoreIcon from "../assets/logo/google.svg.webp";
import appstoreIcon from "../assets/logo/app_store.png";
import { Link } from "react-router-dom";
import { Strings } from "../Common/String";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="social-icons">
        <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" className="social-icon-fb"
        style={{ color: '#1877F2' }}>
          <FacebookIcon />
        </a>
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" className="social-icon-insta" style={{ color: '#C13584' }}>
          <InstagramIcon />
        </a>
      
      </div>
      &nbsp;&nbsp;
      <span style={{ marginTop: '3px', fontWeight: 800 }}> | </span>
      &nbsp;
      <div className="links">
        <Link to="/privacypolicy" className="footer-link">{Strings.PrivacyPolicy}</Link>&nbsp;&nbsp;&nbsp;
        <Link to="/termsconditions" className="footer-link">{Strings.TermsConditions}</Link>
      </div>
      &nbsp;
      <span style={{ marginTop: '5px', fontWeight: 800 }}> | </span>
      &nbsp;
      <div className="footer-text">
        {Strings.Copyright}
      </div>
      &nbsp;
      <span style={{ marginTop: '5px', fontWeight: 800 }}> | </span>
      &nbsp;
      <a href="https://play.google.com/store/apps/details?id=com.pateltechnolab.samajapp" target="_blank" rel="noopener noreferrer">
          <img src={playstoreIcon} alt="Play Store" className="store-icon" style={{ width: '100px', height: '30px' }} />
        </a>
        <a href="https://apps.apple.com/in/app/27-samaj/id6657989074" target="_blank" rel="noopener noreferrer">
          <img src={appstoreIcon} alt="App Store" className="store-icon" style={{ width: '100px', height: '30px' }} />
        </a>
    </footer>
  );
};

export default Footer;
